@if ({
  title: title$ | async,
  showBack: showBack$ | async,
  menus: menus$ | async
  }; as model) {
  @if (isMobile) {
    <ng-container *ngTemplateOutlet="menuContent"></ng-container>
    <hr class="separator separator--gray4" />
  }
  @if (!isMobile) {
    <div class="bg-sosh">
      <ng-container *ngTemplateOutlet="menuContent"></ng-container>
    </div>
  }
  <ng-template #menuContent>
    <div class="site-width bg-sosh">
      <div class="container-fluid">
        <nav class="sticky-navbar navbar mx-0">
          <ul class="navbar-nav">
            @for (menu of model.menus; track menu) {
              <li class="nav-item">
                <a
                  routerLink="{{menu.path}}"
                  [queryParams]='{"sosh": ""}'
                  (click)="selectMenuItem(menu)"
                  class="nav-link"
                  data-e2e="e2e-ecm-sosh-menu-title"
                  [class.item-active]="menu.active"
                  [attr.aria-current]="menu.ariaCurrent"
                  >
                  <span class="text-center">{{menu.label}}</span>
                </a>
              </li>
            }
          </ul>
        </nav>
      </div>
    </div>
    @if (model.showBack) {
      <div class="d-md-none px-1 mt-1">
        <a class="o-link-arrow back" href="" (click)="navigateToBackRoute();false">{{"ecm.menu.return" | translate}}</a>
        <h1 class="h2 no-signature mb-0">{{model.title}}</h1>
      </div>
    }
  </ng-template>
}
